import { createMarcaProdutoApi } from "@/contexts/laboratorio/marcaProduto/api/marcaProdutoApi";
import { MarcaProduto } from "@/contexts/laboratorio/marcaProduto/model/MarcaProduto";
import {
  getMarcaProdutoSynced,
  marcaProdutoAction,
} from "@/contexts/laboratorio/marcaProduto/store/marcaProdutoSlice";
import { SelectOption } from "@/shared/types/SelectOption";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export function useMarcaProduto() {
  const { user } = useAuth();
  const marcaProdutoApi = createMarcaProdutoApi(user?.access_token);
  const listaMarcasProdutos = useSelector(getMarcaProdutoSynced);
  const appDispatch = useDispatch();
  const { sync } = marcaProdutoAction;
  const [marcasOptions, setMarcasOptions] = useState<SelectOption[]>([]);

  const sincronizarMarcasProdutos = (marcas: MarcaProduto[]) => {
    appDispatch(sync(marcas));
  };

  const getMarcasProdutosApi = marcaProdutoApi.listAll;

  const getMarcaProdutoById = (id: number) => {
    return listaMarcasProdutos.find((marca) => marca.id === id);
  };

  const getMarcasProdutosByEstabelecimento = (estabelecimentoId: number) => {
    const marcas = listaMarcasProdutos.filter(
      (marca) => marca.estabelecimento?.id === estabelecimentoId
    );
    const options = marcas.map((marca) => ({
      label: marca.nome ?? "",
      value: marca.id,
    }));
    setMarcasOptions(options);
  };

  return {
    listaMarcasProdutos,
    sincronizarMarcasProdutos,
    getMarcasProdutosApi,
    getMarcaProdutoById,
    marcasOptions,
    getMarcasProdutosByEstabelecimento,
  };
}
